import { gql } from '@apollo/client';
const GET_ORDER_PRODUCTION_MANAGER_DATA = gql `
  query GetOrderProductionManagerData($orderId: ID!) {
    orderProductionManagerData(orderId: $orderId) {
      order {
        id
        orderId
        status
        orderDeliveryDate
        allModelsReady
        allComponentVariantsReady
        createdDate
        modifiedDate
      }
      specifications {
        specification {
          id
          itemCode
          fancyName
          description
          productionTimeMinutes
        }
        modelsCount
        suppliersCount
        sumOfModelQuantities
        totalProductionTimeMinutes
        priority
        latestCollectedDate
        productionApproved
        manufacturer {
          id
          shortName
          fullName
          employeesCount
          picture
          nonWorkingDays {
            id
            startDate
            endDate
          }
        }
        productionStartDate
        virtualProductionEndDate
        manufacturerOccupiedDates
      }
    }
  }
`;
export default GET_ORDER_PRODUCTION_MANAGER_DATA;
